/**
 * Created by admin on 2018/1/26.
 */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import CircleBtn from './CircleBtn';

export default class Extend extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedNum: null
    };
  }

  componentWillReceiveProps(nextProps) {
    const { visible } = nextProps;
    if (!visible) {
      this.setState({ selectedNum: null });
    }
  }

  render() {
    const { onOk, onClose } = this.props;
    const extendNums = [15, 30, 60];
    return (
      <div className={'extend-container'}>
        <div className={'extend-header'}>
          <FormattedMessage id="mc_label_extend" />
        </div>
        <div className={'select-time'}>
          {extendNums.map((num, i) => {
            return (
              <CircleBtn
                mode="light"
                key={i}
                value={[num, 'min']}
                selected={num === this.state.selectedNum}
                callback={() => this.setState({ selectedNum: num })}
              />
            );
          })}
        </div>
        <div className={'operate'}>
          <div className={'btn'} onClick={() => onOk(this.state.selectedNum)}>
            <FormattedMessage id="mc_btn_ok" />
          </div>
          <div className={'btn'} onClick={onClose}>
            <FormattedMessage id="mc_btn_cancel" />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ExtendCMMAMeeting.js